import * as React from 'react';

import { INavMenuProps, NavigationRouteData, UseNavigationRoutesHook } from '@tdp/common/detailsNavigation';

import { NavItem } from './NavItem';
import { NavMenu } from './NavMenu';

export interface ICreateNavMenuOptions<TData extends object = object> {
  hook: UseNavigationRoutesHook<TData>;
  renderNavItem: (item: NavigationRouteData<TData>) => React.ReactNode;
}

/*
 * Utility function for creating a 'Nav Menu' component for a specific data object type.
 */
export function createNavMenu<TData extends object = object>(options: ICreateNavMenuOptions<TData>) {
  return function NavigationMenu(props: Omit<INavMenuProps, 'children'>) {
    const { hook: useNavData, renderNavItem } = options;
    const navData = useNavData();

    return (
      <NavMenu {...props}>
        {navData.map(route =>
          <NavItem key={route.path} href={route.path} active={route.isActive}>
            {renderNavItem(route)}
          </NavItem>
        )}
      </NavMenu>
    )
  }
}
